// extracted by mini-css-extract-plugin
module.exports = {"root":"CollapseCard_root__11hOl","header":"CollapseCard_header__2pd3L"};